module.exports = __webpack_public_path__ + "static/media/sieana.f896ba1b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/sieana.jpeg
// module id = 297
// module chunks = 0